import { Colors } from "../../styles/theme";

const styles = {
  AppBar_container: {
    direction: "ltr",
    backgroundColor: Colors.background,
    padding: 0,
    minHeight: { xs: 60, md: 96 },
    "@media (max-width: 600px) and (max-height: 750px)": {
      padding: "6px 8px",
    },
  },
  AppBar_authContainer: {
    minHeight: { xs: 64, md: 80 },
  },
  AppBar_inner: {
    paddingInline: { xs: "12px", sm: "20px", md: "44px", xl: "54px" },
  },
  AppBar_logo: {
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  },
  AppBar_logoImage: {
    display: "block",
    width: { xs: "min(50vw, 190px)", sm: 250, md: 280, lg: 360, xl: 400 },
    maxWidth: "100%",
    height: "auto",
  },
  AppBar_toolbar: {
    width: "100%",
    justifyContent: { xs: "space-between", md: "flex-start" },
    minHeight: { xs: "52px !important", sm: "56px !important", md: "96px !important" },
    "@media (max-width: 600px) and (max-height: 750px)": {
      minHeight: "44px !important",
    },
  },
  AppBar_authToolbar: {
    minHeight: { xs: "64px !important", md: "80px !important" },
  },
  AppBar_navButtons: {
    display: { xs: "none", lg: "flex" },
    flex: "0 1 auto",
    columnGap: { lg: 2, xl: 3 },
    justifyContent: "flex-start",
    minWidth: 0,
    marginInlineStart: { lg: 3, xl: 4 },
    paddingInline: 0,
  },
  AppBar_navButton: {
    color: Colors.navy,
    fontSize: { xs: "1rem", sm: "1.125rem" },
    fontWeight: 700,
    letterSpacing: 0,
    lineHeight: 1,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "transparent",
      color: Colors.primary,
    },
    alignItems: "center",
    paddingInline: 0,
    py: 1,
    minWidth: "auto",
  },
  AppBar_buttons: {
    flex: { xs: "0 1 auto", md: 1, lg: "0 0 auto" },
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: { xs: 0.25, sm: 0.75, lg: 1.5 },
    minWidth: 0,
    marginInlineStart: "auto",
  },
  AppBar_authButton: {
    fontWeight: 700,
    fontSize: { xs: "1rem", sm: "1.125rem" },
    display: { xs: "none", lg: "inline-flex" },
    "& .MuiButton-endIcon": {
      margin: 0,
      marginInlineStart: 1,
    },
  },
  AppBar_authPageAction: {
    display: "inline-flex",
    minHeight: 40,
    borderRadius: "8px",
    whiteSpace: "nowrap",
    px: { xs: 1.75, sm: 3 },
    py: 1,
    fontSize: { xs: "1rem", sm: "1.125rem" },
  },
  AppBar_menuIcon: {
    alignItems: "center",
    color: Colors.primary,
    width: { xs: 40, sm: 44 },
    height: { xs: 40, sm: 44 },
    padding: 0,
    backgroundColor: "transparent",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "transparent",
      color: Colors.primary,
    },
    "& .MuiSvgIcon-root": {
      fontSize: { xs: 28, sm: 30 },
    },
    "@media (max-width: 600px) and (max-height: 750px)": {
      width: 40,
      height: 40,
    },
  },
  AppBar_menuContainer: {
    display: { xs: "block", lg: "none" },
    mt: 0.75,
    "& .MuiPaper-root": {
      boxSizing: "border-box",
      left: "0 !important",
      right: "0 !important",
      width: "100vw",
      maxWidth: "100vw",
      maxHeight: "calc(100vh - 100px)",
      border: "1px solid #E4EBF4",
      borderRadius: "8px",
      boxShadow: "0 10px 28px rgba(34, 49, 78, 0.14)",
      overflowY: "auto",
    },
    "& .MuiList-root": {
      padding: { xs: 1.5, sm: 2 },
    },
  },
  AppBar_navMenuItem: {
    width: "100%",
    minHeight: { xs: 52, sm: 64 },
    justifyContent: "flex-start",
    color: Colors.navy,
    fontWeight: 700,
    fontSize: { xs: "1rem", sm: "1.125rem" },
    letterSpacing: 0,
    textTransform: "none",
    borderRadius: "6px",
    px: { xs: 1.5, sm: 2 },
    "&:hover": {
      color: Colors.primary,
      backgroundColor: "#EEF5FD",
    },
  },
  AppBar_menuAuthActions: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 1.5,
    borderTop: "1px solid #E4EBF4",
    mt: 1,
    pt: 2,
    px: { xs: 1, sm: 1.5 },
    pb: 1,
  },
  AppBar_menuAuthButton: {
    width: "100%",
    margin: 0,
    fontWeight: 700,
    "& .MuiButton-endIcon": {
      margin: 0,
      marginInlineStart: 1,
    },
  },
  AppBar_menu: {
    flexGrow: 0,
    display: { xs: "flex", lg: "none" },
    justifyContent: "flex-end",
    marginInlineStart: { xs: 0.25, sm: 0.75 },
  },
};
export default styles;
